import { lazy, Suspense } from 'react';
import { useAuth } from '@/contexts/AuthContext';

const DashboardAdmin = lazy(() => import('@/pages/dashboard-admin'));
const DashboardUser = lazy(() => import('./Dashboard'));

export default function DashboardRouter() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500" />
      </div>
    }>
      {isAdmin ? <DashboardAdmin /> : <DashboardUser />}
    </Suspense>
  );
}
